<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-main-sidebar></app-main-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {title: 'You are here : '},
                    
                    {
                      title: 'Question Bank',
                      url: '/#/dashboard/Admin/QuestionBankAdmin',
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="heading mt-3">
              <h3 class="text-secondary">Question Bank</h3>
            </div>
            <!-- <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Training Information</h6>
            </div>-->
          </div>
          <CreateQuestionBank />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateQuestionBank from "../../commonPages/CreateQuestionBank";
import Navbar from "./Navbar";
import mainSidebar from "./main-sidebar";
export default {
  components: {
    "app-navbar": Navbar,
    "app-main-sidebar": mainSidebar,
    CreateQuestionBank
  },
  data: () => ({
    isSidebar: false
  })
};
</script>

<style scoped>
</style>
